import { Box, Link, Typography } from '@mui/material';
import { ChatBubbleOutline, Description, SchoolOutlined, SupportAgent, WhatsApp } from '@mui/icons-material';

import ApiContext from 'contexts/apiContext';
import StoreContext from 'contexts/storeContext';
import { useChatbotEnabled } from 'hooks';
import { makeStyles } from 'tss-react/mui';
import { useContext } from 'react';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  icon: {
    marginTop: 3,
    marginRight: theme.spacing(1),
  },
  semiBold: {
    fontWeight: 600,
  },
}));

export default function HelpScreen() {
  const { classes } = useStyles();
  const { currentUser } = useContext(ApiContext);
  const { store } = useContext(StoreContext);
  const chatbotEnabled = useChatbotEnabled(store, currentUser);

  return (
    <>
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
        Aprende a usar Buen Provecho
      </Typography>
      <Box className={classes.container}>
        <SchoolOutlined fontSize='small' className={classes.icon} />
        <Typography variant='body2'>
          Si quieres <span className={classes.semiBold}>aprender a usar Buen Provecho</span> de la mejor manera, te recomendamos ver
          nuestros{' '}
          <Link
            href='https://www.youtube.com/watch?v=U93aHXD3eGM&list=PLQQ28xyUPFDXHZvruBNC0KPMI3mEpGTGv'
            target='_blank'
            underline='always'
          >
            <b>tutoriales en YouTube</b>
          </Link>
          .
        </Typography>
      </Box>
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
        Propuestas y reportes de error
      </Typography>
      <Box className={classes.container}>
        <ChatBubbleOutline fontSize='small' className={classes.icon} />
        <Typography variant='body2'>
          Si quieres <span className={classes.semiBold}>proponer una nueva funcionalidad</span>,{' '}
          <span className={classes.semiBold}>dejarnos un comentario</span>, o <span className={classes.semiBold}>reportar un error</span>,
          puedes hacerlo a través de{' '}
          <Link href='https://forms.gle/1A6gVzwC5cN1GizGA' target='_blank' underline='always'>
            <b>este formulario</b>
          </Link>
          .
        </Typography>
      </Box>
      {chatbotEnabled && (
        <>
          <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
            Asistente de la plataforma
          </Typography>
          <Box className={classes.container}>
            <SupportAgent fontSize='small' className={classes.icon} />
            <Typography variant='body2'>
              Si tienes dudas sobre <span className={classes.semiBold}>cómo usar la plataforma Buen Provecho</span> (packs, pedidos, horarios, facturación y
              más), puedes usar el <span className={classes.semiBold}>asistente de Buen Provecho</span> tocando el botón de chat en la esquina
              inferior derecha. Te responde al instante, te guía paso a paso y puede llevarte directo a la pantalla que necesites.
            </Typography>
          </Box>
        </>
      )}
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
        Ayuda en línea
      </Typography>
      <Box className={classes.container}>
        <WhatsApp fontSize='small' className={classes.icon} />
        <Typography variant='body2'>
          Si <span className={classes.semiBold}>necesitas ayuda</span> con el uso de la plataforma, ponte en contacto con nosotros a través
          de{' '}
          <Link href={`https://wa.me/${store.country.whatsapp_support_number}`} target='_blank' underline='always'>
            <b>WhatsApp</b>
          </Link>
          .
        </Typography>
      </Box>
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
        Términos y condiciones
      </Typography>
      <Box className={classes.container}>
        <Description fontSize='small' className={classes.icon} />
        <Typography variant='body2'>
          Puedes consultar nuestros{' '}
          <Link href={'https://drive.google.com/file/d/1P1b-Yf_H51Mwk2FLHEnNpUqNVegnm1PA/preview'} target='_blank' underline='always'>
            <b>términos y condiciones</b>
          </Link>
          .
        </Typography>
      </Box>
    </>
  );
}
